var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import Starling from '@ies/starling_client';
import I18n from '@ies/starling_intl';
import { isRN, isTiktok, currentLang, currentLangFromApp, isRTL, isTTP } from '@lib/env_detect';
import RnStore from '@lib/storage';
import currencyFormats from './currency';
import { nativeMonitor } from '../monitor/native';
import { NATIVE_MONITOR_STATUS } from '@src/interface/monitor';
import { formatLanguage } from './languages';
export var STARLING_KEY = '899f53e0567711ec8e2a615c3fc9c46d';
export var STARLING_NAMESPACE = 'Promote_alpha';
var starlingTexts = {};
var _Currency = '';
var _CurrencySymbol = '';
I18n.init({
    lng: currentLang,
    lngFallback: currentLangFromApp,
    formats: __assign({}, currencyFormats),
});
// @ts-ignore
var starling = new Starling({
    apiKey: STARLING_KEY,
    namespace: STARLING_NAMESPACE,
    locale: formatLanguage(currentLang),
    store: isRN ? RnStore : null,
    zoneHost: isTTP
        ? 'https://starling.tiktokv.us'
        : isTiktok
            ? 'https://starling-sg.byteoversea.com'
            : 'https://starling-va.byteoversea.com',
    test: false,
});
var starlingServiceName = 'promote_starling_result';
export var loadI18n = function () { return __awaiter(void 0, void 0, void 0, function () {
    var e_1;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 2, , 3]);
                return [4 /*yield*/, starling.load()];
            case 1:
                starlingTexts = _b.sent();
                if (Object.keys(starlingTexts).length > 0) {
                    nativeMonitor({
                        service: starlingServiceName,
                        status: NATIVE_MONITOR_STATUS.SUCCESS,
                    });
                }
                else {
                    throw new Error('has no abnormal translation');
                }
                return [3 /*break*/, 3];
            case 2:
                e_1 = _b.sent();
                // 兜底文案
                nativeMonitor({
                    service: starlingServiceName,
                    status: NATIVE_MONITOR_STATUS.FAIL,
                    value: {
                        error_message: (_a = e_1.message) !== null && _a !== void 0 ? _a : 'timeout',
                        error_status_code: 10003,
                        options: JSON.stringify(starling.options),
                    },
                });
                starlingTexts = __assign(__assign({}, starlingTexts), require('../../locales/en.json'));
                return [3 /*break*/, 3];
            case 3:
                starlingTexts._price_ = '{_price_}';
                starlingTexts._date_ = '{_date_, date, medium}';
                // @ts-ignore
                I18n.addResourceBundle(currentLang, 'translation', starlingTexts, true, true);
                I18n.setLang(currentLang);
                return [2 /*return*/];
        }
    });
}); };
export var setCurrency = function (currency, currencySymbol) {
    _Currency = currency;
    _CurrencySymbol = currencySymbol;
};
// Price I18n processing
I18n.tPrice = function (key, opt, is_pi, show_coins_icon, is_iap_refactor) {
    var _a;
    if (show_coins_icon === void 0) { show_coins_icon = 1; }
    if (is_iap_refactor === void 0) { is_iap_refactor = false; }
    var text = starlingTexts[key] || '{_price_}';
    var textTemp = isRTL ? "{_price_}" + _CurrencySymbol : _CurrencySymbol + "{_price_}";
    if (is_pi && !is_iap_refactor) {
        if (show_coins_icon) {
            textTemp = '{_coins_} {_price_}';
        }
        else {
            var coinsText = starlingTexts['coins'] || '';
            textTemp = "{_price_} " + coinsText;
        }
    }
    var newText = text.replace('{_price_}', textTemp);
    var texts = (_a = {},
        _a[key] = newText,
        _a);
    // @ts-ignore
    I18n.addResourceBundle(currentLang, 'translation', texts, true, true);
    return I18n.t(key, __assign({}, opt));
};
var rawT = I18n.t;
I18n.t = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    try {
        return rawT.call.apply(rawT, __spreadArray([I18n], args));
    }
    catch (_a) {
        return args[0];
    }
};
I18n.getStarlingTexts = function () { return starlingTexts; };
